import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';

const CustomMuiSelect = ({ options, limit = 2, onChange, value, multiple, placeholder }) => {
  return (
    <div className="custom-mui-select-container">
      <Autocomplete
        multiple={multiple} // Enable or disable multiple selection based on the prop
        options={options} // Options list for selection
        getOptionLabel={(option) => option.label || ''} // Label for options
        isOptionEqualToValue={(option, value) => option.value === value.value} // Match logic for options and value
        value={value} // Current selected value(s)
        onChange={(event, newValue) => onChange(newValue)} // Handles change event
        limitTags={limit || 2} // Limit the number of tags displayed
        renderTags={
          multiple
            ? (selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={index}
                  label={option.label}
                  {...getTagProps({ index })}
                  className="custom-chip"
                />
              ))
            : undefined // No need for renderTags when multiple is false
        }
        disableCloseOnSelect={multiple} // Keep the dropdown open when multiple is true
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              className: 'custom-mui-input',
            }}
            InputLabelProps={{
              className: 'custom-mui-label',
            }}
          />
        )}
        classes={{
          root: 'custom-mui-select',
          popupIndicator: 'custom-popup-indicator',
          clearIndicator: 'custom-clear-indicator',
        }}
      />
    </div>
  );
};

export default CustomMuiSelect;
